import { Component, OnInit } from '@angular/core';
import linksData from '../../assets/links.json';

export enum LinkStatus {
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
  BORED = 'bored',
  HIATUS = 'hiatus',
}

export interface ILink {
  name: string;
  url: string;
  status: string;
  updates?: string;
  recommended?: boolean;
}

const DAYS = String('UMTWHFS').split('');
const INTERMITTENT = 'I';

@Component({
  selector: 'app-links-view',
  templateUrl: './links-view.component.html',
  styleUrls: ['./links-view.component.css']
})
export class LinksViewComponent implements OnInit {

  public comics: ILink[] = linksData.comics;
  public blogs: ILink[] = linksData.blogs.sort( this.sortLinks );
  public updatedToday: ILink[] = [];
  public activeLinks: ILink[] = [];
  public completeLinks: ILink[] = [];
  public incompleteLinks: ILink[] = [];
  public boringLinks: ILink[] = [];

  private dayCode = DAYS[ new Date().getDay() ];

  constructor() {}

  ngOnInit(): void {
    this.updatedToday = this.comics.concat( this.blogs ).filter( this.filterByDayOfWeek.bind(this) ).sort( this.sortLinks );
    this.activeLinks = this.comics.filter( link => this.filterByStatus(link, LinkStatus.ACTIVE) ).sort( this.sortLinks );
    this.activeLinks = this.activeLinks.concat( this.comics.filter( link => this.filterByStatus(link, LinkStatus.HIATUS) ).sort( this.sortLinks ) );
    this.completeLinks = this.comics.filter( link => this.filterByStatus(link, LinkStatus.COMPLETE) ).sort( this.sortLinks );
    this.incompleteLinks = this.comics.filter( link => this.filterByStatus(link, LinkStatus.INCOMPLETE) ).sort( this.sortLinks );
    this.boringLinks = this.comics.filter( link => this.filterByStatus(link, LinkStatus.BORED) ).sort( this.sortLinks );
  }

  private filterByDayOfWeek( link: ILink ): boolean {
    let showToday: boolean = false;
    const today = new Date();
    const firstWeek = today.getDate() < 8;
    if (link.updates.indexOf(this.dayCode) > -1) {
      if (link.status === LinkStatus.ACTIVE) {
        showToday = true;
      } else if (link.status === LinkStatus.HIATUS) {
        // For links on hiatus, only return true if it is the first week of every other month
        showToday = firstWeek && today.getMonth() % 2 === 0;
      }
    } else if (link.updates === INTERMITTENT) {
      // Check every first Monday for intermittent comics
      showToday = this.dayCode === "M" && firstWeek;
    }

    return showToday
  }

  private filterByStatus( link: ILink, status: LinkStatus ): boolean {
    return link.status === status;
  }

  private sortLinks( linkA: ILink, linkB: ILink ): number {
    if (linkA.recommended && !linkB.recommended) {
      return -1;
    } else if (!linkA.recommended && linkB.recommended) {
      return 1;
    } else {
      return linkA.name > linkB.name ? 1 : -1;
    }
  }

}
